import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/track';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async detaillist(params: any) {
    return api.detaillist(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }
}
